import * as sterlingparker from './AllLeagues.styles.sterlingparker';
import * as betprofessor from './AllLeagues.styles.betprofessor';
import * as volcanobet from './AllLeagues.styles.volcanobet';
import * as puntgenie from './AllLeagues.styles.puntgenie';
import * as junglebet from './AllLeagues.styles.junglebet';
import * as fiestabet from './AllLeagues.styles.fiestabet';
import * as puntcity from './AllLeagues.styles.puntcity';
import * as betgalaxy from './AllLeagues.styles.betgalaxy';
import * as betroyale from './AllLeagues.styles.betroyale';
import * as juicybet from './AllLeagues.styles.juicybet';
import * as goldenrush from './AllLeagues.styles.goldenrush';
import * as vikingbet from './AllLeagues.styles.vikingbet';
import * as questbet from './AllLeagues.styles.questbet';
import * as wellbet from './AllLeagues.styles.wellbet';
import * as sugarcastle from './AllLeagues.styles.sugarcastle';
import * as oldgill from './AllLeagues.styles.oldgill';
import * as buffalobet from './AllLeagues.styles.buffalobet';
import * as gigabet from './AllLeagues.styles.gigabet';
import * as slambet from './AllLeagues.styles.slambet';
import * as betstride from './AllLeagues.styles.betstride';
import * as titanbet from './AllLeagues.styles.titanbet';
import * as templebet from './AllLeagues.styles.templebet';
import * as goldenbet888 from './AllLeagues.styles.goldenbet888';
import * as hyperbet from './AllLeagues.styles.hyperbet';
import * as bet777 from './AllLeagues.styles.bet777';
import * as chromabet from './AllLeagues.styles.chromabet';
import * as bet575 from './AllLeagues.styles.bet575';
import * as epicodds from './AllLeagues.styles.epicodds';
import * as pyramidbet from './AllLeagues.styles.pyramidbet';
import * as magnumbet from './AllLeagues.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  betprofessor,
  volcanobet,
  puntgenie,
  junglebet,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  gigabet,
  slambet,
  betstride,
  titanbet,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
